// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_730611dd","outerContainer":"_623b42e0","secondaryToolbar":"b7a6d3d5","doorHangerRight":"a4103a7a","toolbarContainer":"_2678bbed","toolbarViewerMiddle":"_1750c8d3","progressBar":"_05290f17","back-to-application":"_872ba97f","consent":"_5d26ee4c","info":"b4bcd7fd","icon":"_3e69cc5a","title":"_88abcf3a","subtitle":"a761abc7","assignment":"f69de8b8","status":"a0aaec6c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Consents/ConsentItem/styles.styl
// module id = 4938
// module chunks = 39